(() => {
  class ConfirmAutoDeliveryCancellationController {
    constructor($rootScope, $scope, $timeout, $interval, Users, toastr, $state, ngDialog) {
      'ngInject';

      Object.assign(this, {
        $scope,
        $rootScope,
        $timeout,
        $interval,
        Users,
        toastr,
        $state,
        ngDialog,
        cancelReasons: [],
        selectedReason: [],
        auto_refill_off_reason_code: null,
        saveEnabled: false,
        page: 'default'
      });
      $scope.$on('ngDialog.opened', function (e, $dialog) {
        $(".ngdialog-theme-default.ngdialog").children(".ngdialog-content").draggable({
          handle: ".autodelivery-cancellation-popup-handler"
        });
      });
      this.getCancelReasons();
      this.options = [{
        id: '1',
        name: 'User cancelled',
        value: 'cancelled'
      }];
      this.$timeout(function () {
        $("button.md-datepicker-button").css("margin-left", "34px");
        $("input.md-datepicker-input").css("background-color", "#EEEFF2");
      }, 100);
    }

    removeDuplicate() {
      let modals = document.getElementsByClassName("ngdialog");

      if (modals.length > 1) {
        modals[0].remove();
      }
    }

    getCancelReasons() {
      this.Users.getCancelReasons('auto_refill').then(({
        data
      }) => {
        this.cancelReasons = data;
        this.removeDuplicate();
      });
    }

    setCancelReason() {
      this.auto_refill_off_reason_code = this.selectedReason[0].code;
    }

    save() {
      var response = {
        auto_refill: false,
        auto_refill_off_reason_code: this.auto_refill_off_reason_code
      };
      this.$scope.closeThisDialog(response);
    }

    slideUp() {
      this.page = 'cancel';
    }

  }

  ConfirmAutoDeliveryCancellationController.$inject = ["$rootScope", "$scope", "$timeout", "$interval", "Users", "toastr", "$state", "ngDialog"];
  angular.module('pims').controller('ConfirmAutoDeliveryCancellationController', ConfirmAutoDeliveryCancellationController);
})();